import { failToast } from '@utils/toast';
import { CUSTOM_METRICS, reportCustomMetrics } from '@utils/owlReporter';
import * as Ids from '@utils/ids';
import { useCallback, useEffect, useState } from 'react';
import getOldVersionAlert from '../api/getOldVersionAlert';
import { reportWeakAlert } from '../api/reportWeakAlert';
import { AlertType, BizOrgCode } from '../constants';

/**
 * 客户端XP系统使用商家升级引导
 */
const useOldVersionAlertConfig = () => {
    /* 弱升级提示弹窗 */
    const [showSubtleAlertModal, setShowSubtleAlertModal] = useState<boolean>(false);
    /* 弱升级倒计时 */
    const [subtleCountdown, setSubtleCountdown] = useState<number>(0);

    /* 强升级提示弹窗 */
    const [showStrongAlertModal, setShowStrongAlertModal] = useState<boolean>(false);

    /* 获取升级提示配置 */
    const fetchNoticeConfig = useCallback(async () => {
        try {
            const { alertType, confirmTime } = await getOldVersionAlert({
                bizOrgCode: BizOrgCode.WAIMAI,
            });

            setSubtleCountdown(confirmTime);

            reportCustomMetrics(CUSTOM_METRICS.CLIENTV5_FORCE_UPGRADE_REQUEST.KEY, 1, {
                [CUSTOM_METRICS.CLIENTV5_FORCE_UPGRADE_REQUEST.TAGS.ACCT_ID]: Ids.getAcctId(),
                [CUSTOM_METRICS.CLIENTV5_FORCE_UPGRADE_REQUEST.TAGS.POI_ID]: Ids.getWmPoiId(),
                [CUSTOM_METRICS.CLIENTV5_FORCE_UPGRADE_REQUEST.TAGS.TYPE]: alertType,
            });
            switch (alertType) {
                case AlertType.NONE:
                    // 无提示
                    setShowSubtleAlertModal(false);
                    setShowStrongAlertModal(false);
                    break;
                case AlertType.SUBTLE:
                    // 弱提示
                    setShowSubtleAlertModal(true);
                    setShowStrongAlertModal(false);
                    break;
                case AlertType.STRONG:
                    // 强提示
                    setShowSubtleAlertModal(false);
                    setShowStrongAlertModal(true);
                    break;
                default:
                // do nothing
            }
        } catch (err) {
            failToast('获取商家升级引导配置失败');
        }
    }, []);

    useEffect(() => {
        fetchNoticeConfig().catch();
    }, [fetchNoticeConfig]);

    /* 弱升级确认回调 */
    const onSubtleAlertConfirm = useCallback(async () => {
        setShowSubtleAlertModal(false);

        try {
            await reportWeakAlert({ bizOrgCode: BizOrgCode.WAIMAI });
        } catch (err) {
            // do nothing
        }
    }, []);

    return {
        /** 显示弱提示弹窗 */
        showSubtleAlertModal,
        /** 显示强提示弹窗 */
        showStrongAlertModal,
        /** 弱提示弹窗关闭倒计时最大秒数 */
        subtleCountdown,
        /** 弱提示弹窗确认按钮点击 */
        onSubtleAlertConfirm,
    };
};

export default useOldVersionAlertConfig;
